import styled from 'styled-components'

import { fonts, palette } from '../../../../styles/variables'

export default styled.div({
  fontSize: '24px',
  lineHeight: '32px',
  fontWeight: 500,
  fontFamily: fonts.primaryMedium,
  color: palette.darkGray,
  '> b': {
    color: palette.orange,
    fontWeight: 500,
    fontFamily: fonts.primaryMedium,
  },
})
